export const filterOnlyStrings = arr =>
  arr.reduce((acc, value) => {
    if (value && typeof value === 'string' && value.length !== 0) {
      acc.push(value);
    }
    return acc;
  }, []);
